import { render, staticRenderFns } from "./AreaReceiptPaymentChart.vue?vue&type=template&id=04c99fa0&scoped=true&"
import script from "./AreaReceiptPaymentChart.vue?vue&type=script&lang=js&"
export * from "./AreaReceiptPaymentChart.vue?vue&type=script&lang=js&"
import style0 from "./AreaReceiptPaymentChart.vue?vue&type=style&index=0&id=04c99fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c99fa0",
  null
  
)

export default component.exports